// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"purify_scrollDownButton__buttonContainer--3HgR9","iconContainer":"purify_scrollDownButton__iconContainer--2P-lm"};